import { useEffect, useState } from 'react';
import api from '../../schedulerApi';

const useHttpGetDeviceSchedule = deviceId => {
    const [data, setData] = useState(null);
    const [isReady, setIsReady] = useState(false);

    const fetchDeviceSchedule = async () => {
        try {
            const schedule = await api.get_device_schedule(deviceId);
            setData(schedule.data);
        } catch (error) {
            console.error('Unexpected error occurred while fetching device schedule: ', error);
        } finally {
            setIsReady(true);
        }
    };

    useEffect(() => {
        fetchDeviceSchedule();
    }, []);

    return { data, setData, isReady, refetch: fetchDeviceSchedule };
};

export default useHttpGetDeviceSchedule;
